import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { Link } from "react-router-dom";
import HeadSection from "../../components/meta";

const Community = () => {
  return (
    <>
      <HeadSection
        title={"COMMUNITY"}
        keywords={""}
        addPostFixTitle={true}
        largeTwitterCard={true}
        showCanonical={true}
        content={
          "Join Seed to Tree Academy! Connect with learners, explore engaging courses, develop in-demand skills, and unlock your potential to make a lasting impact."
        }
        link={`/community`}
      />
      <Header isActive="community" />
      <div className="community-page">
        <section className="community-sections">
          <div>
            <div className="course__top d-flex justify-content-between align-items-center flex-wrap">
              <div className="course__top__left w-60 community-header">
                <h1>Join Us at Seed to Tree Online Academy</h1>
                <p>
                  Seed to Tree Online Academy is your gateway to a world of
                  limitless possibilities in education. Whether you’re a
                  student, a teacher, or a lifelong learner, there’s a place for
                  you in our community.
                </p>
              </div>

              <div className="w-50 text-end">
                {/* <button className="btn">See All</button>  */}
              </div>
            </div>
          </div>
          <div className="community-cards">
            {/* Teacher Card */}
            <div className="community-card">
              <img
                loading="lazy"
                width={100}
                height={100}
                src="/assets/images/community/community.jpg" // Replace with actual image path
                alt="Join as a Teacher"
                title="Join as a Teacher"
                className="card-image"
              />
              <div className="card-content">
                <h2>Become a Teacher</h2>
                <p>
                  Join our community of passionate educators and inspire the
                  next generation. Share your knowledge and expertise while
                  enjoying numerous benefits.
                </p>
                <Link
                  to="/community/teacher"
                  className="community-link teacher-link"
                >
                  Apply Now
                </Link>
              </div>
            </div>

            {/* Member Card */}
            <div className="community-card">
              <img
                loading="lazy"
                width={100}
                height={100}
                src="/assets/images/community/community.jpg" // Replace with actual image path
                alt="Join as a Member"
                title="Join as a Member"
                className="card-image"
              />
              <div className="card-content">
                <h2>Join as a Member</h2>
                <p>
                  Access high-quality courses across various subjects and
                  enhance your skills. Join a supportive learning community and
                  receive exclusive benefits.
                </p>
                <Link
                  to="/community/member"
                  className="community-link member-link"
                >
                  Join Today
                </Link>
              </div>
            </div>

            {/* Courses Card */}
            <div className="community-card">
              <img
                loading="lazy"
                width={100}
                height={100}
                src="/assets/images/community/community.jpg" // Replace with actual image path
                alt="Explore Courses"
                title="Explore Courses"
                className="card-image"
              />
              <div className="card-content">
                <h2>Join as Student</h2>
                <p>
                  Discover a wide range of courses tailored to your interests
                  and career goals. Learn from industry experts and gain
                  recognized certifications.
                </p>
                <Link to="/courses" className="community-link courses-link">
                  Browse Courses
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Community;
